import styled, { createGlobalStyle } from 'styled-components';

export const Global = createGlobalStyle`
  body {
    height: unset;

    #header {
      display: none;
    }
  }
`;

export const Conteiner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  position: relative;

  margin: 0 112px;
  height: 100% !important;

  h1 {
    font-size: 58px;
    line-height: 81.2px;
    font-weight: 700;
  }

  h2 {
    font-size: 22px;
    line-height: 33px;
    font-weight: 700;
  }

  p {
    font-size: 18px;
    line-height: 27px;
    font-weight: 400;
  }

  button {
    margin-top: 40px;
    max-width: 185px;
  }

  img {
    &:first-of-type {
      margin-top: 32px;
      width: auto;
      height: 60px;
    }

    &:last-of-type {
      margin-top: 142px;
    }
  }

  @media screen and (max-width: 1440px) {
    margin: 0 156px;
  }

  @media screen and (max-width: 834px) {
    margin: 0 70px;

    img {
      &:last-of-type {
        max-width: 100%;
        margin-top: 104px;
      }
    }
  }

  @media screen and (max-width: 428px) {
    margin: 0 32px;

    h2 {
      font-size: 18px;
      line-height: 27px;
    }

    p {
      font-size: 14px;
      line-height: 21px;
    }

    img {
      &:first-of-type {
        height: 50px;
      }

      &:last-of-type {
        max-width: 100%;
        width: 365px;
        height: auto;

        margin-top: 127px;
      }
    }
  }
`;

export const Mensagem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  max-width: 398px;
  margin-top: 16px;

  text-align: center;
`;
